/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SignupCompletionField } from './';
import {
    SignupCompletionFieldFromJSON,
    SignupCompletionFieldFromJSONTyped,
    SignupCompletionFieldToJSON,
} from './';

/**
 * 
 * @export
 * @interface SignupCompletion
 */
export interface SignupCompletion {
    /**
     * 
     * @type {SignupCompletionField}
     * @memberof SignupCompletion
     */
    step: SignupCompletionField;
    /**
     * 
     * @type {string}
     * @memberof SignupCompletion
     */
    completion: SignupCompletionCompletionEnum;
}


/**
 * @export
 */
export const SignupCompletionCompletionEnum = {
    ToComplete: 'TO_COMPLETE',
    Completed: 'COMPLETED',
    Skipped: 'SKIPPED'
} as const;
export type SignupCompletionCompletionEnum = typeof SignupCompletionCompletionEnum[keyof typeof SignupCompletionCompletionEnum];


/**
 * Check if a given object implements the SignupCompletion interface.
 */
export function instanceOfSignupCompletion(value: object): value is SignupCompletion {
    if (!('step' in value) || value['step'] === undefined) return false;
    if (!('completion' in value) || value['completion'] === undefined) return false;
    return true;
}

export function SignupCompletionFromJSON(json: any): SignupCompletion {
    return SignupCompletionFromJSONTyped(json, false);
}

export function SignupCompletionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupCompletion {
    if (json == null) {
        return json;
    }
    return {
        
        'step': SignupCompletionFieldFromJSON(json['step']),
        'completion': json['completion'],
    };
}

export function SignupCompletionToJSON(value?: SignupCompletion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'step': SignupCompletionFieldToJSON(value['step']),
        'completion': value['completion'],
    };
}

